import {
  IconWarning,
  Modal,
  ModalButton,
  ModalContent,
  ModalDismiss,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  useModalState,
} from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { messages } from './messages'
import styles from './origin.css'
type Props = {
  onConfirm: () => void
  onCancel: () => void
  state: ReturnType<typeof useModalState>
}

export function ChangeOriginWarningModal(props: Props) {
  const { state, onCancel, onConfirm } = props
  const { formatMessage: i18n } = useIntl()

  return (
    <Modal state={state} size="small">
      <ModalHeader>
        <ModalTitle className={styles.modalTitle}>
          <IconWarning />
          {i18n(messages.modal.title)}
        </ModalTitle>
        <ModalDismiss />
      </ModalHeader>
      <ModalContent className={styles.modalContent}>
        {i18n(messages.modal.content)}
      </ModalContent>
      <ModalFooter>
        <ModalButton variant="secondary" onClick={onCancel}>
          {i18n(messages.modal.cancel)}
        </ModalButton>
        <ModalButton onClick={onConfirm}>
          {i18n(messages.modal.continue)}
        </ModalButton>
      </ModalFooter>
    </Modal>
  )
}
